export const Constants = {
  clearSearch: 'limpar busca',
};
